import { coresAmbientes } from "./coresAmbientes"
import { obterAmbientesPelosItens } from "./obterAmbientesPelosItens"

export const obterProximaCorAmbiente = () : string => {
    const ambientes = obterAmbientesPelosItens()

    const coresNaoUtilizadas = coresAmbientes.filter(c => ambientes.find(a => a.cor == c) == null)

    return coresNaoUtilizadas.length > 0 ? coresNaoUtilizadas[0] : coresAmbientes[0]
}